export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}course/application/:id`;
    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/CourseApplication/index.js